import { Box, Container, Typography } from "@mui/material";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";

export function ContentRendererParagraph(block: any) {
  return (
    <Container maxWidth="lg" sx={{ my: 4 }}>
      <Box textAlign={block.textAlign}>
        <BlocksRenderer
          blocks={{
            paragraph: (p) => <Typography variant="body1" {...p} />,
          }}
          content={block.content}
        />
      </Box>
    </Container>
  );
}
